<template>
  <div class="base-mit-landing-page mit-page">
      <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">
            <v-card-title>{{appName}}</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <p><a @click="login()">Please sign in.</a></p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import BaseMitConfigService from '../services/BaseMitConfigService.js';
  import BaseMitUserService from '../services/BaseMitUserService.js';

  export default {
    name: 'BaseMitLandingPage',
    components: {
    },
    data: function() {
      return {
        appName:''
      }
    },
    mounted() {
      this.appName = BaseMitConfigService.get('CLIENT_APP_NAME');
    },
    methods: {
        login(){
          BaseMitUserService.login();
        }
    }
  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
</style>
